import { Collection } from 'modules/core/lib/mobx-rest'

import Review from 'modules/attendance/store/models/Review'

class Reviews extends Collection<Review> {
  get cacheKey(): string {
    return 'reviews'
  }

  model() {
    return Review
  }
}

const singleton: Reviews = new Reviews()

export default singleton
